module.exports = __webpack_public_path__ + "static/media/19-Knightsbridge.4aff8953.mp4";